'use strict';

var lang = require('./lang');

module.exports = {
    DURATION: {
        text: lang.i18n.FILTERS.DURATION.name,
        id: 'duration',
        units: 'Days',
        choices: [{
            id: 'week',
            text: lang.i18n.FILTERS.DURATION.choices.week,
            apiValue: {
                value: '7',
                unit: 'day'
            }
        }, {
            id: 'month',
            text: lang.i18n.FILTERS.DURATION.choices.month,
            apiValue: {
                value: '30',
                unit: 'day'
            }
        }, {
            id: 'quarter',
            text: lang.i18n.FILTERS.DURATION.choices.quarter,
            apiValue: {
                value: '12',
                unit: 'week'
            }
        }, {
            id: 'year',
            text: lang.i18n.FILTERS.DURATION.choices.year,
            apiValue: {
                value: '12',
                unit: 'month'
            }
        }, {
            id: 'thisMonth',
            text: lang.i18n.FILTERS.DURATION.choices.thisMonth,
            apiValue: {
                value: 'current',
                unit: 'month'
            }
        }, {
            id: 'custom',
            text: lang.i18n.FILTERS.DURATION.choices.custom,
            nonReporting: true
        }],
        default: 'month',
        custom: 'custom'
    },
    INTERVAL: {
        text: lang.i18n.FILTERS.INTERVAL.name,
        id: 'interval',
        units: '',
        nonReporting: true
    },
    DATE: {
        text: lang.i18n.FILTERS.DATE.name,
        id: 'date',
        units: '',
        choices: [{
            id: 'latest',
            text: lang.i18n.FILTERS.DATE.choices.latest
        }, {
            id: 'custom',
            text: lang.i18n.FILTERS.DATE.choices.custom,
            nonReporting: true
        }],
        default: 'latest',
        custom: 'custom'
    }
};
